var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "my-2" },
        [
          _vm.index > 0
            ? _c("card-content-separator", {
                attrs: { "icon-class": "icon-Add text-primary" },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex justify-content-between align-items-center mb-1",
        },
        [
          _c("div", { staticClass: "col-7" }, [
            _c("h2", { staticClass: "visually-hidden" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.offerPriceDetails.offerType) +
                  " " +
                  _vm._s(_vm.offerPriceDetails.offerName) +
                  "\n            "
              ),
            ]),
            _vm._v(" "),
            _vm.offerPriceDetails.offerType
              ? _c(
                  "p",
                  {
                    staticClass: "pt-xl-1 py-0 mb-0 fw-bold",
                    attrs: { "aria-hidden": "true" },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.offerPriceDetails.offerType) +
                        "\n            "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "h2",
              {
                staticClass: "py-0 mb-0",
                class: _vm.offerPriceDetails.offerType ? "h1" : "h4",
                attrs: { "aria-hidden": "true" },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.offerPriceDetails.offerName) +
                    "\n            "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.showInitialPrice
            ? _c(
                "div",
                { staticClass: "ps-1 text-end" },
                [
                  _c("Price", {
                    attrs: {
                      price: _vm.offerPriceDetails.initialPrice,
                      "show-by-month": true,
                      "is-cents-format": true,
                      "is-compact": true,
                      custom: "text-dark text-decoration-line-through",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.offerPriceDetails.discounts, function (discount, index) {
        return _c(
          "div",
          {
            key: `${_vm.id}-discount-${index}`,
            staticClass: "ob1-inline-promise ob1-inline-promise-warning mb-1",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-between align-items-center w-100",
              },
              [
                _c("div", { staticClass: "col-7 lead" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(discount.label) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-end ps-1" },
                  [
                    _c("Price", {
                      attrs: {
                        price: discount.amount,
                        "show-by-month": true,
                        "is-cents-format": false,
                        "is-mini": true,
                        "price-details": discount.durationLabel || "",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ]
        )
      }),
      _vm._v(" "),
      _vm.offerPriceDetails.cashbacks &&
      _vm.offerPriceDetails.cashbacks.length > 0
        ? _c(
            "div",
            { staticClass: "mb-1" },
            [
              _vm.offerPriceDetails.discounts &&
              _vm.offerPriceDetails.discounts.length > 0
                ? _c("hr", {
                    staticClass: "dotted-separator my-1",
                    attrs: { "aria-hidden": "true" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.offerPriceDetails.discounts &&
              _vm.offerPriceDetails.discounts.length > 0
                ? _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-between align-items-center pb-2",
                    },
                    [
                      _c("span", { staticClass: "fw-bold" }, [
                        _vm._v(
                          _vm._s(_vm.offerPriceDetails.discountedPriceLabel)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("Price", {
                        attrs: {
                          price: _vm.offerPriceDetails.discountedPrice,
                          "initial-price":
                            _vm.offerPriceDetails.discountedPermanentPrice,
                          "show-by-month": true,
                          "is-cents-format": true,
                          "is-mini": true,
                          "show-promo-duration":
                            _vm.discountType === "PROMO_DURATION",
                          "show-end-of-promotion-price":
                            _vm.discountType === "END_OF_PROMO",
                          custom: "text-dark",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(
                _vm.offerPriceDetails.cashbacks,
                function (cashback, index) {
                  return _c(
                    "div",
                    {
                      key: `${_vm.id}-cashback-${index}`,
                      staticClass:
                        "ob1-inline-promise ob1-inline-promise-warning mb-1",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-between align-items-center w-100",
                        },
                        [
                          _c("div", { staticClass: "col-7" }, [
                            _c("p", {
                              directives: [
                                {
                                  name: "msh-html",
                                  rawName: "v-msh-html",
                                  value: cashback.label,
                                  expression: "cashback.label",
                                },
                              ],
                              staticClass: "lead mb-0",
                            }),
                            _vm._v(" "),
                            cashback.url
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "ob1-link underline-link",
                                    attrs: {
                                      href: cashback.url,
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                      "aria-label":
                                        cashback.ctaLabel +
                                        " (nouvelle fenêtre)",
                                    },
                                  },
                                  [_vm._v(_vm._s(cashback.ctaLabel))]
                                )
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "text-end ps-1" },
                            [
                              _c("Price", {
                                attrs: {
                                  price: cashback.amount,
                                  "show-by-month": true,
                                  "is-cents-format": false,
                                  "is-mini": true,
                                  "price-details":
                                    cashback.durationLabel +
                                    "<br>" +
                                    cashback.invoiceMention,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  )
                }
              ),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", [
        _c("hr", {
          staticClass: "dotted-separator mb-1",
          attrs: { "aria-hidden": "true" },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex justify-content-between align-items-start" },
          [
            _c("p", {
              directives: [
                {
                  name: "msh-html",
                  rawName: "v-msh-html",
                  value: _vm.offerPriceDetails.finalPriceLabel,
                  expression: "offerPriceDetails.finalPriceLabel",
                },
              ],
              staticClass: "fw-bold mb-0",
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-end" },
              [
                _c("Price", {
                  key: _vm.id + "-final-price",
                  attrs: {
                    price: _vm.offerPriceDetails.finalDiscountedPrice,
                    "initial-price": _vm.offerPriceDetails.finalPermanentPrice,
                    "price-details":
                      _vm.offerPriceDetails.finalPriceDurationLabel,
                    duration: _vm.offerPriceDetails.finalPriceDuration,
                    "is-cents-format": true,
                    "is-mini": true,
                    "show-by-month": true,
                    "show-promo-duration":
                      _vm.finalDiscountType === "PROMO_DURATION",
                    "show-end-of-promotion-price":
                      _vm.finalDiscountType === "END_OF_PROMO",
                    "cashback-type": _vm.cashbackType,
                  },
                }),
              ],
              1
            ),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }